import React from 'react';
import map from '../../../assets/images/map.jpg';
import m_map from '../../../assets/images/m_map.png';
import KaKaoMap from './KakaoMap';


export default function Content() {
  return (
    <>
      <div className="s1_3_content">
        <div className="center pb-3">
          <p className="prt-bold fs-40 fc-black1 txt-left mb-3">오시는 길</p>

          <div className="map_box relative">
            {/* <img src={map} alt="" className="m-none t-none" /> */}
            {/* <img src={m_map} alt="" className="pc-none w-100 " /> */}

            <KaKaoMap />
            
            <div className="row-flex m-col-flex info_container">
              <div className="loc_info flex-center relative w-20">
                <div className="w-70 h-70 col-flex between txt-left lh-15">
                  <p className="prt-light fs-18 fc-white ">Location</p>

                  <p className=" ">
                    <span className="prt-bold fs-24 fc-white">(주) 크림봇</span>
                    <br />
                    <span className="fs-18 fc-white prt-bold">creambot</span>
                  </p>
                </div>
              </div>

              <div className="loc_info_txt absolute txt-left flex-wrap w-80">
                <div className="info row-flex between flex-wrap ">
                  <div className="info_item m-mb-20 t-mb-20">
                    <div className="row-flex-center gap-30 mb-5">
                      <span className="info_dot fc-005eed">■</span>
                      <span className="info_title prt-bold fs-22 fc-black1">
                        주소
                      </span>
                    </div>

                    <div className="info_content fs-18 lh-15">
                      <p>
                        <span className="prt-regular fc-black1">본사 :</span>
                        <span className="prt-light fc-91 ml-2">
                          {/* 인천광역시 서구 이음 4로 10, 518-521호 */}
                          인천 서구 로봇랜드로 155-11 1306호
                        </span>
                      </p>
                      <p>
                        <span className="prt-regular fc-black1">
                          연구센터 :
                        </span>{' '}
                        <br className="pc-none" />
                        <span className="prt-light fc-91 ml-2 m-ml-0">
                          서울특별시 강남구 강남대로 364길 #1, 2층 201호
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="info_item m-mb-20">
                    <div className="row-flex-center gap-30 mb-20">
                      <span className="info_dot fc-005eed">■</span>
                      <span className="info_title prt-bold fs-22 fc-black1">
                        전화
                      </span>
                    </div>

                    <div className="info_content fs-18 lh-15">
                      <p>
                        <span className="prt-light fc-91 ml-2">1555-3811</span>
                      </p>
                    </div>
                  </div>

                  <div className="info_item">
                    <div className="row-flex-center gap-30 mb-8 ">
                      <span className="info_dot fc-005eed">■</span>
                      <span className="info_title prt-bold fs-22 fc-black1">
                        이메일
                      </span>
                    </div>

                    <div className="info_content fs-18 lh-15">
                      <p>
                        <span className="prt-light fc-91 ml-2">
                          bomembers@naver.com
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
